export enum CreditErrorType {
  BANK,
  GENERIC,
  REQUEST,
  RISK,
  SCORE,
  IDENTITY,
  SMS,
  NO_NETWORK,
  CREATE,
  HAVE_LOAN,
  MAINTENANCE,
  PLATFORM_DISABLED,
}

export type CreditError = {
  title?: string;
  messages: string[];
  whatsapp?: string;
  popupInfo?: {
    linkText: string;
    content: string;
  };
  showPartners?: boolean;
};

const whatsapp = 'https://crediflow.es/contacto';

export const creditErrors = new Map<CreditErrorType | undefined, CreditError>([
  [
    CreditErrorType.MAINTENANCE,
    {
      messages: ['En este momento no podemos procesar su solicitud, vuelva a intentarlo mas tarde.'],
      whatsapp,
    },
  ],
  [
    CreditErrorType.PLATFORM_DISABLED,
    {
      messages: ['Gracias por tu interés en Crediflow. En este momento no tenemos créditos para ofrecerte.'],
    },
  ],
  [
    CreditErrorType.GENERIC,
    {
      messages: ['Ocurrió un error inesperado...'],
      whatsapp,
    },
  ],
  [
    CreditErrorType.BANK,
    {
      title: 'No podemos concederte el préstamo solicitado.',
      messages: [
        'Ocurrió un error con verificación de cuenta bancaria...',
        'Nuestro análisis de capacidad de pago y solvencia (socre crediticio) ha rechazado la solicitud.',
        ' ',
        ' ',
        '¿De qué se trata?',
        'De forma muy resumida, se trata de una herramienta que utilizan las entidades financieras para decidir si concede el préstamo en función de tu capacidad de endeudamiento y de tu solvencia. Se analiza la deuda, ingresos y egresos del cliente para determinar si puede realizar el pago.',
      ],
      whatsapp,
    },
  ],
  [
    CreditErrorType.CREATE,
    {
      messages: ['Ocurrió un error inesperado...'],
      whatsapp,
    },
  ],
  [
    CreditErrorType.REQUEST,
    {
      messages: ['No pudimos procesar su solicitud. Para más información comuniquese con atención al cliente.'],
      whatsapp,
    },
  ],
  [
    CreditErrorType.HAVE_LOAN,
    {
      title: 'Ya posee un préstamo activo.',
      messages: ['No podemos procesar su solicitud. Ya posee un préstamo activo.'],
      whatsapp,
    },
  ],
  [
    CreditErrorType.RISK,
    {
      title: 'No podemos concederte el préstamo solicitado.',
      messages: [
        'Nuestro análisis de fraude, capacidad de pago y solvencia (socre crediticio) ha rechazado la solicitud.',
      ],
      whatsapp,
    },
  ],
  [
    CreditErrorType.SMS,
    {
      messages: ['No podemos procesar tu solicitud...parece tu número telefónico es incorrecto'],
      whatsapp,
    },
  ],
  [
    CreditErrorType.SCORE,
    {
      title: 'No podemos concederte el préstamo solicitado.',
      messages: [
        'Nuestro análisis de capacidad de pago y solvencia (score crediticio) ha rechazado la solicitud.',
      ],
      whatsapp,
      popupInfo: {
        linkText: '¿De qué se trata?',
        content: 'De forma muy resumida, se trata de una herramienta que utilizan las entidades financieras para decidir si concede el préstamo en función de tu capacidad de endeudamiento y de tu solvencia. Se analiza la deuda, ingresos y egresos del cliente para determinar si puede realizar el pago.',
      },
      showPartners: true,
    },
  ],
  [
    CreditErrorType.IDENTITY,
    {
      messages: ['No podemos procesar tu solicitud... no pudimos validar tu identidad'],
      whatsapp,
    },
  ],
  [
    CreditErrorType.NO_NETWORK,
    {
      messages: [
        'No podemos procesar tu solicitud, hubo un error con tu conexión',
        'Conéctate a internet de nuevo y vuelve a intentarlo',
      ],
      whatsapp,
    },
  ],
  [
    undefined,
    {
      messages: ['Error no especificado'],
      whatsapp,
    },
  ],
]);
